module.exports = __webpack_public_path__ + "img/DownloadByLuciditv.ccb82add.png";